export default __webpack_public_path__ + "static/media/lock.897ff7b3.png";